import useModal from '@fipnooone/react-modal';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Api, Code } from '@.api';
import { Auth } from '@/Services';

import { BrandActionConfirmModal } from '../ui/BrandActionConfirmModal';

export const useArchiveBrand = () => {
    const auth = Auth.Use();

    const [modal, modalControls] = useModal();

    const navigate = useNavigate();

    const handleArchive = useCallback(
        (brandId?: number) => {
            if (!brandId) {
                throw new Error('Brand id is required');
            }

            const createArchiveAction = (withProducts: boolean) => async () => {
                const response = await Api.brands().archive(brandId, withProducts);

                if (response.code !== Code.Success) {
                    alert(response.message);
                }

                modalControls.close();

                navigate(0);
            };

            const getBrandPreviewProducts = async (brandId: number) => {
                const response = await Api.brands().getArchivePreviewProducts(brandId);

                if (response.code === Code.Success) {
                    return response.data.products;
                }

                return [];
            };

            modalControls.set(
                <BrandActionConfirmModal
                    brandId={brandId}
                    title="Are you sure you want to archive the brand?"
                    confirmBrandText="Archive only brand"
                    confirmPartialText="Archive brand and all products"
                    actionOnlyBrand={createArchiveAction(false)}
                    actionBrandWithProducts={createArchiveAction(true)}
                    getPreviewProducts={getBrandPreviewProducts}
                    close={() => modalControls.close()}
                />
            );
        },
        [modalControls, navigate]
    );

    return {
        modal,
        auth,
        handleArchive,
    };
};
